import { Capacitor } from '@capacitor/core';

// ============================================================
// API CONFIGURATION
// ============================================================
//
// LOCAL WEB DEVELOPMENT:
//   http://localhost:5000/api
//
// MOBILE / CAPACITOR DEVELOPMENT:
//   http://192.168.1.186:5000/api
//
// PRODUCTION:
//   https://gimbiya.onrender.com/api
//
// ============================================================

const USE_LOCAL_API = false;

const LOCAL_IP = '192.168.1.186';
const LOCAL_PORT = '5000';

const PRODUCTION_API_URL =
  'https://gimbiya.onrender.com/api';

// ============================================================
// PLATFORM DETECTION
// ============================================================

const platform = Capacitor.getPlatform();
const isNative = Capacitor.isNativePlatform();

// Detect whether the app is running in a mobile browser/device
const isMobileBrowser =
  typeof window !== 'undefined' &&
  /Android|iPhone|iPad|iPod/i.test(
    window.navigator.userAgent
  );

// ============================================================
// API URL
// ============================================================

const getApiUrl = (): string => {
  // ----------------------------------------------------------
  // PRODUCTION
  // ----------------------------------------------------------

  if (!USE_LOCAL_API) {
    console.log(
      '🌐 Production API detected:',
      PRODUCTION_API_URL
    );

    return PRODUCTION_API_URL;
  }

  // ----------------------------------------------------------
  // LOCAL DEVELOPMENT
  // ----------------------------------------------------------

  // Native Capacitor Android/iOS
  if (isNative) {
    const url = `http://${LOCAL_IP}:${LOCAL_PORT}/api`;

    console.log(
      `📱 Native ${platform} detected - using local network API:`,
      url
    );

    return url;
  }

  // Mobile browser
  if (isMobileBrowser) {
    const url = `http://${LOCAL_IP}:${LOCAL_PORT}/api`;

    console.log(
      '📱 Mobile browser detected - using local network API:',
      url
    );

    return url;
  }

  // Desktop browser
  const url = `http://localhost:${LOCAL_PORT}/api`;

  console.log(
    '💻 Desktop web development detected - using local API:',
    url
  );

  return url;
};

export const API_URL = getApiUrl();

// ============================================================
// WEBSOCKET URL
// ============================================================
//
// API_URL:
//   http://192.168.1.186:5000/api
//
// becomes:
//   ws://192.168.1.186:5000
//
// ============================================================

export const WS_URL = API_URL
  .replace('https://', 'wss://')
  .replace('http://', 'ws://')
  .replace('/api', '');

// ============================================================
// IMAGE URL
// ============================================================

export const getImageUrl = (path: string) => {
  if (!path) {
    return '';
  }

  // Already a complete URL
  if (
    path.startsWith('http://') ||
    path.startsWith('https://')
  ) {
    return path;
  }

  // Backend base URL without /api
  const SERVER_URL = API_URL.replace('/api', '');

  // Existing uploads path
  if (path.startsWith('/uploads')) {
    return `${SERVER_URL}${path}`;
  }

  return `${SERVER_URL}/uploads/${path}`;
};

// ============================================================
// DEBUG
// ============================================================

console.log('🔧 ===== CONFIGURATION DEBUG =====');
console.log('🔧 Platform:', platform);
console.log('🔧 Is Native:', isNative);
console.log('🔧 Is Mobile Browser:', isMobileBrowser);
console.log('🔧 Local API Enabled:', USE_LOCAL_API);
console.log('🔧 Final API_URL:', API_URL);
console.log('🔧 WebSocket URL:', WS_URL);
console.log(
  '🔧 Image URL Example:',
  getImageUrl('/uploads/example.jpg')
);
console.log('🔧 ================================');